import React, { useEffect, useState, useCallback } from "react";
import { getPaymentMethods } from "./PaymentMethods.slice";
import { refreshPaymentMethodsPage } from "./refreshPaymentMethodsPage";
import { PaymentMethodsTable } from "./components/PaymentMethodsTable";
import { getPaymentMethodColumns } from "./columns";
import { CButton, CFade } from "@coreui/react";
import AddBankAccountModal from "./AddBankAccountModal";
import AddCreditCardModal from "./AddCreditCardModal";
import { trackEvent } from "./../../utils/analytics";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { isOwnerEnrolledInAutopay } from "../Dashboard/components/setAutopayPaymentMethod";

export const PaymentMethods: React.FC = () => {
  const [bankModal, setBankModal] = useState(false);
  const [creditCardModal, setCreditCardModal] = useState(false);

  const { loading: loadingAS, data: accountData, activeTenantAccountIndex } =
    useAppSelector((state) => state.accountSummary);
  const { loading: loadingPM } = useAppSelector((state) => state.payment.methods);
  const dispatch = useAppDispatch();
  const getPaymentMethodsCB = useCallback(() => {
    dispatch(getPaymentMethods()).catch((e: string) => {
      throw new Error(e);
    });
  }, [dispatch]);
  const refreshPaymentMethodsCB = useCallback(() => {
    return refreshPaymentMethodsPage(dispatch);
  }, [dispatch]);

  useEffect(() => {
    getPaymentMethodsCB();
    trackEvent({ action: "View > Payment Methods" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const accountSummaryData = accountData?.[activeTenantAccountIndex];
  const isOwnerAutopayEnrolled = accountSummaryData
    ? isOwnerEnrolledInAutopay(accountSummaryData)
    : false;
  const columns = getPaymentMethodColumns(
    isOwnerAutopayEnrolled,
    isOwnerAutopayEnrolled ? accountSummaryData?.autopay?.paymentMethodId : null
  );

  if (loadingPM || loadingAS) {
    return <div>Loading...</div>;
  }

  const toggleBankModal = () => {
    setBankModal(!bankModal);
  };

  const toggleCreditCardModal = () => {
    setCreditCardModal(!creditCardModal);
  };

  return (
    <CFade>
      <div className="flex-grow-1 justify-content-center">
        <div className="card">
          <header className="card-header" style={{ border: 0 }}>
            <h2>Payment Methods</h2>
          </header>
          <PaymentMethodsTable
            columns={columns}
            onPaymentMethodsChanged={refreshPaymentMethodsCB}
          />
          <div className="card-footer">
            <CButton onClick={toggleBankModal} color="primary">
              Add Bank Account
            </CButton>
            <CButton
              onClick={toggleCreditCardModal}
              color="primary"
              style={{ marginLeft: 10 }}
            >
              Add Credit Card
            </CButton>
          </div>
        </div>
      </div>
      <AddBankAccountModal setModal={setBankModal} modal={bankModal} />
      {creditCardModal && (
        <AddCreditCardModal
          setModal={setCreditCardModal}
          modal={creditCardModal}
        />
      )}
    </CFade>
  );
};

export default PaymentMethods;
